<h6 class="loginHeadingText text-start">KEY DATES</h6>
<div class="row mb-12px mt-16">
    <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center">
        <label>Initiated Date</label>
    </div>
    <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 pe-3">
        <span class="font-13" id="initiatedDate">{{keyDatesInfo.initiatedDate | date:'dd-MMM-yyyy'}}</span>
        <!-- <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}" 
            (ngModelChange)="onLeadTimeChange($event)" [disabled]="disableAfterReview"
            [(ngModel)]="ldDate"> </p-calendar> -->
    </div>
</div>
<div class="row mb-12px mt-16">
    <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center">
        <label>START DATE</label>
    </div>
    <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 text-end pe-3">
            <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}" 
                (ngModelChange)="onStartDateChange($event)" 
                [minDate]="minDateForStartDate!"
                [disabled]="disableAfterReview"
                [(ngModel)]="keyDatesInfo.startDate"> </p-calendar>
    </div>

    
</div>

<div class="row mb-12px mt-16">
    <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center">
        <label>END DATE</label>
    </div>
    <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 pe-3">
        <!-- <span class="font-13" id="endDate">{{keyDatesInfo.endDate | date:'dd-MMM-yyyy'}}</span> -->
        <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}" 
            (ngModelChange)="onEndDateChange($event)" id ="endDate"
            [disabled]="disableAfterReview"
            [minDate]="minDateForEndDate!"
            [(ngModel)]="keyDatesInfo.endDate"> </p-calendar>
    </div>
</div>

<div class="row mb-12px mt-16">
    <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center pe-0">
        <label>SUBMITTED FOR REVIEW</label>
    </div>
    <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 pe-3">
        <span class="font-13" id="submittedDate">{{keyDatesInfo.submittedDate | date:'dd-MMM-yyyy'}}</span>
    </div>
</div>

<div class="row mb-12px mt-16">
    <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center">
        <label>APPROVED ON</label>
    </div>
    <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 pe-3">
        <span class="font-13" id="approvedOn">{{keyDatesInfo.approvedOn | date:'dd-MMM-yyyy'}}</span>
    </div>
</div>


<!-- <div class="row mb-12px mt-16">
    <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center">
        <label>PWR DATE</label>
    </div>
    <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 text-end pe-3">
        <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}" 
            (ngModelChange)="onPWRDateChange($event)" [disabled]="!enablePWR"            
            [minDate]="aprDate!"
            [(ngModel)]="pwrDate"> </p-calendar>
    </div>
</div> -->